module.exports = __webpack_public_path__ + "static/media/digitel.af6a3753.svg";